<app-page headline="Buyers">
  <DataTable
    [datasource]="buyers"
    [columns]="buyerColumns"
    height="calc(100vh - 300px)"
    (rowClick)="handleRowClick($event)"
  >
    <div
      row-layout
      paddingLeft="lg"
      ngProjectAs="data-table-header"
      justifyContent="space-between"
      alignItems="center"
    >
      <div row-layout gap="md">
        <Tooltip label="Add Buyer" placement="right">
          <button
            icon-button
            symbolName="person_add"
            (click)="addBuyer()"
            size="md"
          >
            Add Buyer
          </button>
        </Tooltip>
        <Tooltip label="Red Flag Buyer Companies" placement="right">
          <button
            icon-button
            symbolName="account_circle_off"
            (click)="addRedFlagBuyer()"
            size="md"
          >
            Red Flag Buyer Companies
          </button>
        </Tooltip>
        <button text-button size="md" (click)="synchronizeBuyerLoginData()">
          Sync
        </button>
      </div>

      <oui-data-search
        label="Search:"
        labelTextRole="headline-small"
        [datasource]="buyers"
        [fields]="[
          'firstName',
          'lastName',
          'email',
          'roles',
          'buyerCompanyNumber',
        ]"
      />
    </div>
  </DataTable>
</app-page>

<Dialog [show]="showDialog()" (showing)="handleDialogShow($event)">
  <DialogHeader>{{
    !!selectedBuyer() ? 'Edit Buyer' : 'Add Buyer'
  }}</DialogHeader>

  <div
    grid-layout
    templateColumns="auto 1fr"
    gap="sm"
    padding="md"
    style="width: 400px"
  >
    <div box-layout display="flex" alignItems="center">
      <Text role="headline-small" color="on-primary-surface-variant">
        First Name
      </Text>
    </div>
    <app-input
      [form]="buyerForm"
      controlName="firstName"
      [invalid]="
        buyerForm.controls['firstName'].invalid &&
        buyerForm.controls['firstName'].touched
      "
    />

    <div box-layout display="flex" alignItems="center">
      <Text role="headline-small" color="on-primary-surface-variant">
        Last Name
      </Text>
    </div>
    <app-input
      [form]="buyerForm"
      controlName="lastName"
      [invalid]="
        buyerForm.controls['lastName'].invalid &&
        buyerForm.controls['lastName'].touched
      "
    />

    <div box-layout display="flex" alignItems="center">
      <Text role="headline-small" color="on-primary-surface-variant"
        >Email</Text
      >
    </div>
    <app-input
      [form]="buyerForm"
      controlName="email"
      type="email"
      [invalid]="
        buyerForm.controls['email'].invalid &&
        buyerForm.controls['email'].touched
      "
    />

    <div box-layout display="flex" alignItems="center">
      <Text role="headline-small" color="on-primary-surface-variant">Role</Text>
    </div>
    <app-select
      [form]="buyerForm"
      controlName="role"
      [options]="roleOptions()"
      placeholder="...select a role"
      [invalid]="
        buyerForm.controls['role'].invalid && buyerForm.controls['role'].touched
      "
    ></app-select>

    <div box-layout display="flex" alignItems="center">
      <Text role="headline-small" color="on-primary-surface-variant">
        Buyer Company Number
      </Text>
    </div>
    <app-input
      [form]="buyerForm"
      controlName="buyerCompanyNumber"
      [invalid]="
        buyerForm.controls['buyerCompanyNumber'].invalid &&
        buyerForm.controls['buyerCompanyNumber'].touched
      "
    />
    @if (dialogError()) {
      <div box-layout gridColumn="span 2">
        <Text color="on-warn-container" display="block">{{
          dialogError()
        }}</Text>
      </div>
    }
  </div>

  @if (!!selectedBuyer()) {
    <div row-layout justifyContent="end">
      <button
        text-button
        variant="ghost"
        size="md"
        (click)="confirmDelete()"
        style="text-decoration: underline; color: #ff7200"
      >
        Delete Buyer
      </button>
    </div>
  }

  <div center-layout>
    <button
      text-button
      size="md"
      (click)="saveBuyer()"
      variant="tertiary"
      [loading]="saving()"
      [disable]="buyerForm.invalid"
    >
      Save
    </button>
  </div>
</Dialog>

<Dialog
  [show]="showRedFlagBuyerDialog()"
  (showing)="showRedFlagBuyerDialog.set($event)"
>
  <DialogHeader>{{ 'Red Flag Buyer Companies' }}</DialogHeader>
  @if (permissionToUpload()) {
    <div stack-layout padding="md" gap="md" alignItems="center">
      <Text role="headline-small"> Upload New RedFlag Buyer File </Text>
      <oui-file-drop-zone
        #fileDropZone
        [height]="160"
        (fileAttached)="handleFileAttached($event)"
        (fileRemoved)="selectedFile.set(undefined)"
        style="width: 100%"
        [helpTemplate]="fileDropZoneContent"
      />
      <ng-template #fileDropZoneContent>
        <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
          <Text role="headline-small" align="center">
            Drag and drop the file here.
          </Text>
          <Text role="title-small" align="center">
            Only .xlsx files with headers buyer_company_number will be accepted.
          </Text>
        </div>
      </ng-template>
      <div
        row-layout
        justifyContent="space-between"
        [fullWidth]="true"
        gap="md"
      >
        <button
          text-button
          size="md"
          variant="secondary"
          (click)="fileDropZone.openFileSelector()"
        >
          Browse Files
        </button>
        <button
          text-button
          size="md"
          (click)="uploadFile(selectedFile())"
          [disable]="!selectedFile()"
        >
          Upload
        </button>
      </div>
    </div>
  }
</Dialog>
